module.exports = __webpack_public_path__ + "static/media/salemu-logo.02a5d4b5.png";